module.exports = __webpack_public_path__ + "img/atras.8e89918b.svg";